import { render, staticRenderFns } from "./doctor-form.vue?vue&type=template&id=05d2bb4a&"
import script from "./doctor-form.vue?vue&type=script&lang=js&"
export * from "./doctor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports